import {
  QueryFunction,
  QueryKey,
  useQuery,
  UseQueryOptions,
} from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { MatsterApiService, WeightBridgeListResponse } from 'features/master/api/master-api.service';
import { UserListParams } from 'features/users';
import qs from 'qs';

import { MaterQueryKeys } from './query-keys';
const { getWeightBridge } = MatsterApiService();

const getWBQuery = (
  params: UserListParams,
  options?: UseQueryOptions<WeightBridgeListResponse>,
): {
  queryKey: QueryKey;
  queryFn: QueryFunction<WeightBridgeListResponse>;
  options?: UseQueryOptions<WeightBridgeListResponse>;
} => ({
  queryKey: MaterQueryKeys.list(params),
  queryFn: ({ signal }) =>
    getWeightBridge(params, {
      config: {
        signal,
        paramsSerializer: {
          serialize: (queryParams) =>
            qs.stringify(queryParams, {
              arrayFormat: 'repeat',
              encode: true,
            }),
        },
      },
    }),
  ...options,
});

export const useGetWeightBridgeList = (
  params: any,
  options?: UseQueryOptions<WeightBridgeListResponse>,
) => {
  const { message } = App.useApp();
     
  return useQuery<WeightBridgeListResponse, Error>(
    getWBQuery(params, {
      onError: (error: unknown) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      ...options,
    }),
  );
};








